import { rightsSchema } from './common';

import { jObjectBaseSchema, jObjectLittleSchema } from './objectBase';
import { z } from 'zod';
import { jUserLittleSchema } from './user';

export const onyOfficeFileInfoSchema = z.object({
    color: z.string(),
    description: z.string(),
    extension: z.string(),
    icon: z.string(),
    label: z.string(),
});
export type OnlyOfficeFileInfo = z.infer<typeof onyOfficeFileInfoSchema>;

export const onlyOfficeFileSchema = jObjectBaseSchema.extend({
    title: z.string(),
    mimetype: z.string(),
    _extend: z.object({
        generalAccessRule: z.string(),
        generalAccessHash: z.union([z.string(), z.undefined()]),
        dateModified: z.string(),
        dateCreation: z.string(),
        fileInfo: onyOfficeFileInfoSchema,
        parentId: z.number(),
        parentType: z.string(),
        parentFiles: z.array(z.number()),
        _url: z.string(),
    }),
    _right: rightsSchema,
    _user: jUserLittleSchema,
    _audience: z.array(jObjectLittleSchema),
});
export declare type OnlyOfficeFile = z.infer<typeof onlyOfficeFileSchema>;
